import { createAsyncThunk } from '@reduxjs/toolkit';
import { CropImageDocumentSignalRResponse, ImageDocumentStoreItem } from '@v2/components/imageHandling/types/types.d';
import { AppDispatch, RootState } from '@store/types';
import { calculateCropDimensions, generateImageUrls, generatePageUrls } from '@reducers/v2/imageHandlingV2/thunks';
import { updateImageDocumentInDict } from '@reducers/v2/imageHandlingV2/imageHandlingV2.slice';

interface CropImageDocumentMessageHandlerPayload extends Pick<CropImageDocumentSignalRResponse, 'documentId' | 'cropSettings'> {}

export const cropImageDocumentMessageHandler = createAsyncThunk<void, CropImageDocumentMessageHandlerPayload, { dispatch: AppDispatch }>(
  'imageHandlingV2/cropImageDocumentMessageHandler',
  async ({ cropSettings, documentId }, { dispatch, getState }) => {
    const rootState = getState() as RootState;
    const imagesDocumentsDict = rootState.imageHandlingV2?.imagesDocumentsDict;
    const imageFromStore = imagesDocumentsDict[documentId];

    if (!imageFromStore) return;

    const updatedCropDimensions = cropSettings
      ? calculateCropDimensions({
          pageNumber: imageFromStore.pageNumber,
          height: imageFromStore.heightOriginal,
          width: imageFromStore.widthOriginal,
          customAngle: cropSettings.rotationAngle,
          cropSettings: [cropSettings],
        })
      : {};

    const updatedImage = {
      ...imageFromStore,
      ...updatedCropDimensions,
      cropSettings: imageFromStore?.cropSettings
        ? imageFromStore.cropSettings?.map((cs) => (cs.pageNumber === cropSettings.pageNumber ? cropSettings : cs))
        : [cropSettings],
    } as ImageDocumentStoreItem;

    let urls = null;

    if (updatedImage.isPDF) {
      urls = await generatePageUrls({
        cropSettings: updatedImage.cropSettings,
        imageDocument: updatedImage,
        dispatch,
        pageNumber: updatedImage.pageNumber,
      });
    } else {
      urls = await generateImageUrls(updatedImage, dispatch);
    }

    dispatch(updateImageDocumentInDict({ documentId, updatedImageDocument: { ...updatedImage, isProcessing: false, ...urls } }));
  }
);
